<template>
  <Technology>
    <div class="techData">
      <div class="techData-search">
        <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2;border: none;"
        >新增
        </el-button>
        <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
        <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            clearable
            @clear='search'
        >
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </div>

      <div id="table">
        <!--动态绑定长宽-->
        <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            @selection-change="tabSelect"
            :header-cell-style="headerStyle"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column type="index" width="150" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center"></el-table-column>
          <el-table-column prop="status" label="是否发布" align="center">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status == 1">已发布</el-tag>
              <el-tag type="info" v-else>未发布</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <!-- <el-button-group> -->
              <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
              <el-button
                  type="primary"
                  size="mini"
                  @click="preview(scope.row)"
                  v-if="scope.row.status==2"
              >确定发布
              </el-button>
              <el-button size="mini" type="warning" @click="preview(scope.row)" v-else>取消发布</el-button>
              <!-- </el-button-group> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
      ></el-pagination>

      <el-dialog :title="Title" :visible.sync="dialogFormVisible" :append-to-body="true" :close-on-click-modal='false'
                 @closed="is_submit= true">
        <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="75px"
            :rules="rules"
            class="demo-ruleForm"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="ruleForm.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="时间" prop="dateTime">
            <el-date-picker
                v-model="ruleForm.dateTime"
                :picker-options="pickerOptions"
                type="datetime"
                placeholder="选择日期"
                style="text-align: left;width:100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="text-align:left" prop="file">
            <el-upload
                class="upload-demo"
                :action="this.uploadURL"
                :file-list="ruleForm.file"
                :on-success="handlePreview"
                :before-upload="beforeHandlePreview"
                :before-remove="beforeRemove"
            >
              <el-button size="small" type="primary">上传文件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="发布:" prop="status" style="text-align:left">
            <el-col :span="12">
              <el-switch
                  v-model="ruleForm.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="2"
              ></el-switch>
            </el-col>
            <el-col :span="12" style="text-align:right">
              <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
              <el-button @click="closeForm('ruleForm')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </Technology>
</template>

<script>
import Technology from "./technology";
import {DisabledDateFn} from '../../utils/tool'

export default {
  components: {
    Technology
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit: true,
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE"
      },
      selected: "",
      searchValue: "",
      total: 10,
      per_page: 10,
      currentPage: 1,
      dialogFormVisible: false,
      Title: "",
      ruleForm: {
        title: "",
        dateTime: "",
        status: "",
        file: []
      },
      tableData: [
        {
          title: "测试",
          content: "测试",
          status: 1
        },
        {
          title: "测试",
          content: "测试",
          status: 2
        }
      ],
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          }
        ],
        dateTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        file: [
          {
            required: true,
            message: "请上传文件"
          }
        ]
        // type:[{required: true, message: '请选择类型', trigger: 'change'}],
      }
    };
  },
  created() {
    this.getData('Material')
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData(url) {
      let params = {};
      if (url.indexOf('?') > -1) {
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/material/page`, params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
          //   this.tableData.forEach(item => {
          //     item.content = item.content
          //       .replace(/\<\/?.*?\>/g, "")
          //       .replace(/\&nbsp\;/g, "");
          //   });
        }
      });
    },
    //发布
    preview(e) {
      let data = {};
      if (e.status == 1) {
        data.status = 2;
      } else if (e.status == 2) {
        data.status = 1;
      }
      data.id = e.id;
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/material/update`, data).then(res => {
        if (res.code == 0) {
          if (data.status == 1) {
            this.$message.success("发布成功");
          } else {
            this.$message.success("已取消发布");
          }
          this.getData("Material");
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //新增
    add() {
      this.Title = "新建";
      this.dialogFormVisible = true;
      this.ruleForm = {
        title: "",
        dateTime: "",
        status: "2",
        file: []
      };
    },
    //编辑
    handleEdit(val) {
      this.Title = "编辑";
      this.dialogFormVisible = true;
      this.ruleForm = JSON.parse(JSON.stringify(val))
      delete this.ruleForm.address

      this.ruleForm.file = []
      this.ruleForm.file.push({
        name: val.title,
        url: val.address
      })
    },
    //提交
    submitForm(formName) {
      if (!this.is_submit) {
        return false
      }
      this.is_submit = false;

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.dateTime = this.pbcFun.formatDate(
              new Date(this.ruleForm.dateTime),
              "yyyy-MM-dd hh:mm:ss"
          );
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          obj.address = this.ruleForm.file[0].url
          delete obj.file
          if (!obj.id) {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/material/create`, obj).then(res => {
              if (res.code == 0) {
                this.ResetSearch(['searchValue'])

                this.$message.success("新建成功");
                this.getData("Material");
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            }).catch(err => {
              this.is_submit = true
            });
          } else {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/material/update`, obj).then(res => {
              if (res.code == 0) {
                this.ResetSearch(['searchValue'])

                this.$message.success("编辑成功");
                this.getData("Material");
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            }).catch(err => {
              this.is_submit = true
            });
          }
        } else {
          this.is_submit = true;

          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //搜索
    search() {
      this.getData("Material?title=" + this.searchValue)
    },
    //删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
          .then(() => {
            this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/material/delete?id=` + row.id, "", "delete").then(res => {
              if (res.code == 0) {
                this.ResetSearch(['searchValue'])

                this.getData("Material");
                this.$message({
                  type: "success",
                  message: "删除成功"
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
    },
    //批量删除
    deleteAll() {
      if (this.selected) {
        this.$confirm("确定删除文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
            .then(() => {
              this.http
                  .request(`${urlConfig.devUrl}apij2/admin-api/trade/material/batchDelete?ids=` + this.selected, "", "delete")
                  .then(response => {
                    if (response.code == 0) {
                      this.ResetSearch(['searchValue'])

                      this.$message.success("删除成功！");
                      this.getData("Material");
                    }
                  });

            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的文件"
        });
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData("Material?title=" + this.searchValue + "&page=" + val)
    },
    //选择行数
    tabSelect(sec) {
      let ids = "";
      for (let i of sec) {
        ids += i.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    //上传文件
    handlePreview(response, file, fileList) {
      this.ruleForm.file.push({
        name: file.name,
        url: response.data.store_result
      });
    },
    beforeHandlePreview(file) {
      if (this.ruleForm.file.length >= 1) {
        this.$message.warning(`当前限制上传 1个文件`);
        return false;
      }
      let type = false;
      if (
          file.name.indexOf(".doc") != -1 || file.name.indexOf(".xls") != -1
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传文件应为doc或xls格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    beforeRemove(file, fileList) {
      if (fileList.length == 1) {
        this.ruleForm.file = [];
      } else {
        this.ruleForm.file[0].name = fileList[0].name;
        this.ruleForm.file[0].url = fileList[0].url;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.techData {
  width: 100%;

  .techData-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      background-color: #e5f3fe !important;
      color: #623aa2;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }
}
</style>
